import createReducer from "../../lib/createReducer";
import * as types from "../../actions/types";

const initialState = {
  items: [],
  createdItem: null,
};

export default createReducer(initialState, {
  [types.VEHICLES_SET_PIPELINES_SHARINGS](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.items = action.state.sharings;

    return newState;
  },

  [types.VEHICLES_SET_CREATED_PIPELINES_SHARING](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    newState.createdItem = action.state.sharing;
    newState.items.unshift(newState.createdItem);

    return newState;
  },

  [types.VEHICLES_SET_DELETED_PIPELINES_SHARING](state, action) {
    const newState = JSON.parse(JSON.stringify(state));

    const { entityId } = action.state;
    newState.items = newState.items.filter((i) => i.entityId !== entityId);

    return newState;
  },
});
